import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { AdminService } from "./services/admin/admin.service";
import { Router, NavigationEnd, ActivatedRoute, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NgxPullToRefreshModule } from 'ngx-pull-to-refresh';
import { MatIconModule } from '@angular/material/icon';
import { LanguageService } from './services/language/language.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    NgxPullToRefreshModule,
    MatIconModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  isOpen = true;
  showSidebar: boolean = true;
  id: number | null = null;

  targetElement: Element;

  currentLang = 'ge'

  @ViewChild('verifyModal') verifyModal: any;

  @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef;

  ngAfterViewInit() {
    this.targetElement = this.scrollContainer?.nativeElement || document.querySelector('html');
  }


  constructor(
    public admin: AdminService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private langService: LanguageService
  ) {
    
  }

  ngOnInit() {
    this.targetElement = document.querySelector('html');
   
    this.handleSidebarOnScreenResize();
    this.subscribeToRouterEvents();

    this.currentLang = this.langService.getLanguage();

    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
    });
   
  }


  // Subscribe to router events to get nested route parameters and handle sidebar visibility
  subscribeToRouterEvents() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap(route => route.params)
      )
      .subscribe(params => {
        this.id = params['id'] || null;
         const isAuthRoute = 
          this.router.url === '/signin' || 
          this.router.url === '/not-found';

        if (isAuthRoute) {
          this.showSidebar = false;
        } else {
          this.showSidebar = true;
        }
      
        // Avoid unnecessary navigation calls
        if (this.router.url !== this.router.url) {
          this.router.navigate([this.router.url]); // ასეთი კოდის თავიდან აცილება
        }
      });
  }

  // Close sidebar if screen is small (<= 768px)
  handleSidebarOnScreenResize() {
    if (window.innerWidth <= 768) {
      this.isOpen = false;
    }
  }

  // Toggle navigation (menu)
  toggleNav(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  menuItemClicked() {
    if (window.innerWidth <= 768) {
      this.isOpen = false;
    }
  }

  closeSidebar(event: Event) {
    if (window.innerWidth <= 768 && this.isOpen) {
      this.isOpen = false;
      event.stopPropagation();
    }
  }

  // HostListener to dynamically handle window resize events
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 768) {
      this.isOpen = true; // Open sidebar for larger screens
    } else {
      this.isOpen = false; // Close sidebar for smaller screens
    }
  }


  logout(){
    this.admin.logout()
  }

  switchLanguage(lang: string): void {
    if (lang !== this.currentLang) {
      this.langService.setLanguage(lang);
      // Optional: გვერდის გადატვირთვა საჭიროების შემთხვევაში
      // location.reload(); 
    }
  }

  
}